import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import { Controller, useForm, ErrorMessage } from 'react-hook-form';
import { Grid, Checkbox, FormLabel, Paper, Button, InputLabel, FormControl, Select, MenuItem } from '@material-ui/core';
import { useStyle } from './style';
import { DIRECT_DEBIT_INFORMATION, DEBIT_TERMS_AND_CONDITIONS } from './constants';
import { TextField, Typography } from '@material-ui/core';
import errormesages from './errormessages';
import { masterData } from "./data";
import axios from 'axios';
import Loading from '../shared/Loading';
import EirRemindMe from './EirRemindMe';


export default function EirPaymentDebitInformation(props) {
    const { control, errors, handleSubmit, setValue } = useForm({
        reValidateMode: 'onChange',
    });
    const { validation } = errormesages;
    const accHolderNameInputRef = useRef();
    const bankIdentifierCodeInputRef = useRef();
    const intBankAccNumberInputRef = useRef();
    const timeAtBankInputRef = useRef();
    const { setDebitTandCStatus } = props;
    const { setBankDetailsStatus } = props;
    const { setDebitTandCError } = props;
    const debitTandCError = props.debitTandCError;
    const [checkBankdetailsButton, setCheckBankDetailsButton] = useState(true);
    const [bankDetailsSuccess, setBankDetailsSuccess] = useState(false);
    const [displayModel, setdisplayModel] = useState(false);
    const [ibanValue, setibanValue] = useState(null);
    const [bicValue, setbicValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [bankDetailsFailure, setBankDetailsFailure] = useState(false);
    const [bankDetailsFailureMsg, setBankDetailsFailureMsg] = useState(null);
    var polCounter = 0;
    useEffect(() => {
        bankIdentifierCodeInputRef.current.value = bicValue;                        //setting value initially when component is loaded
        intBankAccNumberInputRef.current.value = ibanValue;
        setTimeout(() => {
            if (bicValue !== null && ibanValue !== null) {
                setValue('bankIdentifierCode', bicValue, { shouldDirty: true });    //setting updated values to textfields
                setValue('intBankAccNumber', ibanValue, { shouldDirty: true });
            }
        }, [1000]);
    }, [bicValue, ibanValue]);

    const bicRef = useCallback(bicValue => {
        if (bicValue !== undefined) {
            bankIdentifierCodeInputRef.current = bicValue;
        }
    }, []);
    const ibanRef = useCallback(ibanValue => {
        if (ibanValue !== undefined) {
            intBankAccNumberInputRef.current = ibanValue;
        }
    }, []);

    const classes = useStyle();

    const handleCheckbox = (e) => {
        setDebitTandCStatus(e.target.checked);
        setDebitTandCError(!(e.target.checked));
    }

    const onClick = data => {
        polCounter = 0; //reset the polling counter to 0 for retry
        checkBankDetails(data);
    }
    async function checkBankDetails(data) {
        setLoading(true);
        let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
        const bankIdentifierCode=data.bankIdentifierCode.replace(/ /g, "");
        const intBankAccNumber=data.intBankAccNumber.replace(/ /g, "");
        var bodyFormData = new FormData();
        bodyFormData.append('bic', bankIdentifierCode);
        bodyFormData.append('iban', intBankAccNumber);
        bodyFormData.append('timeAtBank', 'fake');
        bodyFormData.append('orderId', orderId);
        bodyFormData.append('acceptTerms', true);
        bodyFormData.append('paymentDDTermsConditions', true);
        /*******/
        try {
            let urlPath = '/store/api/checkout/submit-bank-details/';
            let res = await axios({
                method: 'POST',
                url: urlPath,
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            if (res.status == 200) {
                if (res.data.success) {
                    bankDetailsPoll();
                } else {
                    setLoading(false);
                    //console.log(res.data.success);
                }
            } else {
                console.log(res);
            }
        }
        catch (err) {
            console.error(err);
        }
        /*******/
    }

    async function bankDetailsPoll() {
        polCounter++;//increasing counter
        let orderId = JSON.parse(localStorage.getItem("eir_be_data")).order.id;
        var endpoint = '/store/api/checkout/bank-details-poll/' + orderId;
        /*******/
        try {
            let res = await axios({
                method: 'GET',
                url: endpoint,
                cache: false,
                dataType: 'JSON',
                processData: false,
                contentType: false,
            })
            if (res.status == 200) {
                if (res.data.completed) {
                    if (res.data.success) {
                        setLoading(false);
                        setCheckBankDetailsButton(false);
                        setBankDetailsSuccess(true);
                        setBankDetailsStatus(true);
                    } else {
                        setLoading(false);
                        setBankDetailsFailure(true);
                        if (res.data.validationErrors.length > 0)
                            setBankDetailsFailureMsg('Something went wrong: please submit your bank details again.');
                        else
                            setBankDetailsFailureMsg('Something went wrong: please submit your bank details again.');
                    }
                } else {
                    if (polCounter <=20)
                        setTimeout(bankDetailsPoll, 4000);
                    else {
                        setLoading(false);
                        setBankDetailsFailure(true);
                        setBankDetailsFailureMsg('Something went wrong: please submit your bank details again.')
                    }
                }
            } else {
                setLoading(false);
                //console.log(res);
            }
        }
        catch (err) {
            console.error(err);
        }
        /*******/
    }
    const popup = () => {
        setdisplayModel(true);
    }

    const toggleModel = () => {
        setdisplayModel(false);
    }
    return (
        <Fragment>
            <form>
                <Grid item sm={12} className={classes.debitInfoPadding}>
                    <Paper className={classes.PaymentPaper} variant='elevation' elevation={4}>
                        <Grid container>
                            <Grid item sm={6}>
                                <h2 className={classes.debitHeadingTxt1}>Direct Debit Information</h2>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography className={classes.reqTextPayment}><span style={{ color: 'red', textAlign: 'center' }} >*</span> Required Fields</Typography>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <FormLabel className={classes.paymentFormLabelColor}> {DIRECT_DEBIT_INFORMATION} </FormLabel>
                                </Grid>
                            </Grid>
                            <h2 className={classes.debitHeadingTxt2} >Direct Debit terms & conditions</h2>
                            <Grid container spacing={2}>
                                <Grid item m={2} xs={12}>
                                    <FormLabel className={classes.paymentFormLabelColor}> {DEBIT_TERMS_AND_CONDITIONS} </FormLabel>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} className={classes.checkboxContainer}>
                                <Checkbox
                                    color="primary"
                                    onChange={(event) => handleCheckbox(event)}
                                    className={classes.checkbox}
                                />
                                <FormLabel className={classes.checkboxTxt}  >
                                    I agree with the direct debit terms and conditions above <span style={{ color: 'red', textAlign: 'center' }} >*</span>  </FormLabel>
                            </Grid>
                            {debitTandCError &&
                                <p className={classes.errorMessageCheckbox}>Please check the box to confirm you have read and accept the direct debit Terms and Conditions.</p>}
                            <Grid item xs={12}>
                                <Typography className={classes.reqTextPaymentMob}><span style={{ color: 'red', textAlign: 'center' }} >*</span> Required Fields</Typography>
                            </Grid>
                            <Grid container sm={12} xs={12} className={classes.gridDownSpacePayment}>
                                <Grid item sm='3' xs={12} className={classes.paymentLeftTxtBox}>
                                    <Controller
                                        as={<TextField inputRef={accHolderNameInputRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="accHolderName"
                                        name="accHolderName"
                                        label="Account Holder Name"
                                        variant="outlined"
                                        size="small"
                                        required
                                        error={Boolean(errors.accHolderName)}
                                        rules={{
                                            required: { value: true, message: validation.accHolderNameRequired },
                                            minLength: { value: 2, message: validation.accHolderNameMinLength },
                                            maxLength: { value: 100, message: validation.accHolderNameMaxLength },
                                            pattern: { value: /^([^0-9]*)$/, message: validation.accHolderNamePattern }
                                        }}
                                    />
                                    <ErrorMessage errors={errors} name="accHolderName">
                                        {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                    </ErrorMessage>
                                </Grid>
                                <Grid item sm='3' xs={12} className={classes.paymentRightTxtBox}>
                                    <Controller
                                        as={<TextField inputRef={bicRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="bankIdentifierCode"
                                        name="bankIdentifierCode"
                                        label="Bank Identifier Code (BIC)"
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={(bicValue) && { shrink: true }}
                                        required
                                        error={Boolean(errors.bankIdentifierCode)}
                                        rules={{
                                            required: { value: true, message: validation.bankIdentifierCodeRequired },
                                            minLength: { value: 2, message: validation.bankIdentifierCodeMinLength },
                                            maxLength: { value: 100, message: validation.bankIdentifierCodeMaxLength },
                                        }}
                                    />
                                    <ErrorMessage errors={errors} name="bankIdentifierCode">
                                        {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                    </ErrorMessage>
                                    <a href="#" type="link" onClick={popup} className={classes.linkText}>Remind me of my BIC </a>
                                </Grid>
                            </Grid>
                            <Grid container sm={12} xs={12} className={classes.gridDownSpacePayment}>
                                <Grid item sm='3' xs={12} className={classes.paymentLeftTxtBox}>
                                    <Controller
                                        as={<TextField inputRef={ibanRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="intBankAccNumber"
                                        name="intBankAccNumber"
                                        label="International Bank Account Number (IBAN)"
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={(ibanValue) && { shrink: true }}
                                        required
                                        error={Boolean(errors.intBankAccNumber)}
                                        rules={{
                                            required: { value: true, message: validation.intBankAccNumberRequired },
                                            minLength: { value: 2, message: validation.intBankAccNumberMinLength },
                                            maxLength: { value: 100, message: validation.intBankAccNumberMaxLength },
                                        }}
                                    />
                                    <ErrorMessage errors={errors} name="intBankAccNumber">
                                        {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                    </ErrorMessage>
                                    <a href="#" type="link" onClick={popup} className={classes.linkText}>Remind me of my IBAN </a>
                                </Grid>
                                {/* <Grid item sm={3} xs={12} className={classes.paymentRightDd}>
                                    <FormControl color="secondary" variant="outlined" fullWidth size="small">
                                        <InputLabel required
                                        >Time with Current Bank </InputLabel>
                                        <Controller
                                            control={control}
                                            name="timeAtBank"
                                            id="timeAtBank"
                                            inputRef={timeAtBankInputRef}
                                            defaultValue=""
                                            rules={{ required: { value: true, message: validation.timeAtBankRequired } }}
                                            error={Boolean(errors.timeAtBank)}
                                            as={
                                                <Select
                                                    id='timeAtBank'
                                                    label="Time with Current Bank"
                                                >
                                                    {masterData.filter(masterData => masterData.id === 'timeAtBank').map((data) =>
                                                        data.value.map((val) =>
                                                        (
                                                            <MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
                                                                {val.label}
                                                            </MenuItem>
                                                        ))
                                                    )}
                                                </Select>
                                            }
                                        />
                                        <Grid className={classes.errorMessage}>
                                            <ErrorMessage errors={errors} name='timeAtBank'>
                                                {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                            </ErrorMessage>
                                        </Grid>
                                    </FormControl>
                                </Grid> */}
                            </Grid>
                            {loading ? '' :
                                checkBankdetailsButton ?
                                    <Grid container sm={7} xs={12} className={classes.checkBankDetails}>
                                        <Grid item sm='3' xs={12} className={classes.checkBankDetailsItem} >
                                            <Button className={classes.checkBankDetailsBtn} onClick={handleSubmit(onClick)} > Check Bank Details</Button>
                                        </Grid>
                                    </Grid> : ''
                            }
                            {loading ? <Loading /> :
                                bankDetailsSuccess ?
                                    <Grid container sm={7} xs={12} className={classes.checkSuccess}>
                                        <Grid item sm='2' xs={5} className={classes.tickIcon} >
                                        </Grid>
                                        <Grid item sm='10' xs={7} className={classes.successTxtContainer}>
                                            <p className={classes.successTxt}>Your bank details were checked successfully</p>
                                            <a href="" className={classes.changeBankDetails}>Change Bank Details</a>
                                        </Grid>
                                    </Grid> : bankDetailsFailure ?
                                        <Grid container sm={7} xs={12}>
                                            <Grid item sm={10} xs={12}>
                                                <p className={classes.IBNErrorTxt}>{bankDetailsFailureMsg}</p>
                                            </Grid>
                                        </Grid> : ''
                            }
                        </Grid>
                    </Paper>
                </Grid>
            </form>
            {displayModel &&
                <EirRemindMe
                    displayModel={displayModel}
                    setdisplayModel={setdisplayModel}
                    toggleModel={toggleModel}
                    setibanValue={setibanValue}
                    setbicValue={setbicValue}
                ></EirRemindMe>}
        </Fragment >
    );
}